import React from "react";
import S from "../../styles/components";
import ListContext from "./ListContext";
import ListNodeLabel from "./ListNodeLabel";
import { isEqual } from "lodash";

class ListNode extends React.PureComponent {
  static contextType = ListContext;

  state = {
    collapsed: true,
  };

  toggleCollapse = () => {
    const { collapsed } = this.state;

    this.setState({ collapsed: !collapsed });
  };

  handleClick = () => {
    const { value, isClickable = true } = this.props;
    if (!isClickable) return;
    const { onChange, selections } = this.context;

    const selected = selections.some((selection) => isEqual(selection, value));

    if (selected) {
      onChange(
        selections.filter((selection) => !isEqual(selection, value)),
        [value]
      );
    } else {
      onChange(
        [value],
        selections.filter((selection) => !isEqual(selection, value))
      );
    }
  };

  render() {
    const { children, id, title, badge, value, icon } = this.props;
    const { collapsed } = this.state;
    const { selections } = this.context;

    const selected = selections.some((selection) => isEqual(selection, value));

    if (!React.Children.count(children)) {
      return (
        <ListNodeLabel
          title={title}
          badge={badge}
          icon={icon}
          selected={selected}
          onClick={this.handleClick}
        />
      );
    }

    return (
      <S.ListGroup selected={selected}>
        <S.ListGroupHeader>
          <ListNodeLabel
            title={title}
            badge={badge}
            icon={icon}
            selected={selected}
            collapsed={collapsed}
            onToggleCollapse={this.toggleCollapse}
            onClick={this.handleClick}
          />
        </S.ListGroupHeader>
        <S.ListGroupBody collapsed={collapsed}>{children}</S.ListGroupBody>
      </S.ListGroup>
    );
  }
}

export default ListNode;
